export const COMMAND_QUERY_PARAM = 'commands';

// Likely remove on FG cleanup smart_links_for_plans
export const COMMAND_STORAGE_KEY = 'commands';
